import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  PNGlobalContext,
  SET_IDG_FILTER,
  RESET_REFRESH_PN_DATA,
  SET_REFETCH_ALL_PROGRESS_NOTES_PENDING,
} from '@mummssoftware/global-context/PNGlobalContext';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Context } from '../../context';
import { ReqFieldDiv } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

const StyledSwitch = withStyles((theme) => ({
  switchBase: {
    color: theme.palette.common.white,
    '&$checked': {
      color: theme.palette.primary.main,
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  checked: {},
  track: {},
}))(Switch);

export const IDGNotesSwitch = ({ showFilter }: any) => {
  const { idgMeetingId, smallWidget } = useContext(Context);
  const { idgFilter, dispatchPN, refreshPNData } = useContext(PNGlobalContext);
  const handleChange = () => {
    const nextIdgFilter = !idgFilter;
    if (idgFilter && !nextIdgFilter) {
      dispatchPN({
        type: SET_REFETCH_ALL_PROGRESS_NOTES_PENDING,
        payload: true,
      });
    }
    dispatchPN({ type: SET_IDG_FILTER, payload: nextIdgFilter });
    if (refreshPNData.count) {
      dispatchPN({ type: RESET_REFRESH_PN_DATA });
    }
  };

  return !!idgMeetingId && !smallWidget && !showFilter ? (
    <div style={{ paddingRight: '5px' }}>
      <Typography component="div" variant="body2" style={{ letterSpacing: 0 }}>
        <Grid component="div" container alignItems="center">
          <ReqFieldDiv>{defaults.allNotes}</ReqFieldDiv>
          <Grid item>
            <StyledSwitch
              checked={idgFilter}
              onChange={handleChange}
              name="checked"
            />
          </Grid>
          <ReqFieldDiv>{defaults.idgNotes}</ReqFieldDiv>
        </Grid>
      </Typography>
    </div>
  ) : (
    <></>
  );
};
export default IDGNotesSwitch;
